import { render } from "./EmailReplyDetailView.vue?vue&type=template&id=6c7ac524&scoped=true"
import script from "./EmailReplyDetailView.vue?vue&type=script&lang=js"
export * from "./EmailReplyDetailView.vue?vue&type=script&lang=js"

import "./EmailReplyDetailView.vue?vue&type=style&index=0&id=6c7ac524&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7ac524"]])

export default __exports__